import './App.css';
import { sub } from "date-fns";

/**
 * Calculates and displays an equated date based on provided parameters.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {string} [props.equateDate] - The pre-calculated equate date, if available.
 * @param {string} [props.appointedDate] - The appointed date, used if equateDate is not provided.
 * @param {number} [props.termLength] - The term length in years, used to calculate the equate date if provided.
 * @param {string} props.content - The text content to display alongside the calculated date.
 * @returns {JSX.Element} A div element containing the content and formatted equate date.
 */
function EquateDate(props) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  let date;
  if(props.equateDate){
    date = props.equateDate;
  }
  else{
    if(props.termLength){
        let appointedDate = new Date(props.appointedDate);
        let totalTermLength = props.termLength;
        let termLengthDifference = sub(new Date(appointedDate), { years: (totalTermLength / 2) });
        date = termLengthDifference;
    }
    else{
        date = props.appointedDate;
    }
  }

  
  return (
    <>
        <div className="equate-date">
            <p className='content'>{props.content} <br/><strong>{new Date(date).toLocaleDateString("en-US", options)}</strong></p>
        </div>
    </>
  );
}

export default EquateDate;